import * as moment from "moment";

export const jobStatusMapping = ['Planned', 'In Progress', 'Completed', 'Cancelled'];

export function formatFileSize(size) {
  var i = -1;
  var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
  do {
    size = size / 1024;
    i++;
  } while (size > 1024);

  return Math.max(size, 0.1).toFixed(1) + byteUnits[i];
}

export function formatDate(date, format) {
  if (date) {
    let dateFormat = format ? format : 'DD/MM/YYYY HH:mm';
    let testDateUtc = moment.utc(date);
    return testDateUtc.local().format(dateFormat);
  }
  return "";
}

export function formatDateToUTC(date, format) {
  if (date) {
    let dateFormat = format ? format : 'DD/MM/YYYY HH:mm';
    let testDateUtc = moment(date).utc();
    return testDateUtc.format(dateFormat);
  }
  return "";
}

export function formatPhone(obj) {
  var numbers = obj.value.replace(/\D/g, ''),
    char = {0: '(', 2: ') ', 6: '  '};
  obj.value = '';
  for (var i = 0; i < numbers.length; i++) {
    obj.value += (char[i] || '') + numbers[i];
  }
  return obj.value;
}

export function addBlankTargets(s) {
  let ss = ("" + s).replace(/<a\s+href=/gi, '<a target="_blank" href=');
  return ss;
}

export function formatAmount(val) {
  const neg = val.startsWith('-');

  val = val.replace(/[-\D]/g, '');
  val = val.replace(/(\d{1,2})$/, '.$1');
  val = val.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

  val = val != '' ? '$' + val : '';
  if (neg) val = '-'.concat(val);
  return val;
}
